(function ($) {
  $(document).ready(function () {
    if ($('.hm-review').length) {
      $('.hm-review').each(function () {
        const $block = $(this);
        const $slider = $block.find('.js-hm-review__slider').get(0);
        const $next = $block.find('.js-hm-review__nav__btn-next').get(0);
        const $prev = $block.find('.js-hm-review__nav__btn-prev').get(0);

        const swiperConfig = {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: $next,
                prevEl: $prev,
            },
            breakpoints: {
                750: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                }
            }
        };


        /* eslint-disable-next-line no-unused-vars */
        const logoCarouselSlider = new Swiper($slider, swiperConfig);
      });
    }
  });
})(jQuery);
